import PropTypes from "prop-types";
import RightSideDrawer from "../RightSideDrawer";
import DrawerSection from "../DrawerSection";
import DetailRow from "../DetailRow";

const ManagementDrawer = ({
    isOpen,
    onClose,
    title,
    width = "520px",
    sections = [],
    footer = null,
}) => {

    return (
        <RightSideDrawer
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            width={width}
        >
            {
                sections.map((section, sectionIndex) => (
                    <DrawerSection
                        key={sectionIndex}
                        title={section.title}
                    >
                        {
                            section.fields
                                ? (
                                    section.fields.map((field, fieldIndex) => (

                                        <DetailRow
                                            key={fieldIndex}
                                            label={field.label}
                                            value={field.value}
                                            editable={field.editable}
                                            type={field.type}
                                            options={field.options}
                                            onChange={field.onChange}
                                        />
                                    ))
                                )
                                : section.content
                        }
                    </DrawerSection>
                ))
            }

            {footer}
        </RightSideDrawer>
    );
};

ManagementDrawer.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    width: PropTypes.string,
    footer: PropTypes.node,

    sections: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            fields: PropTypes.array,
            content: PropTypes.node,
        })
    ),
};

export default ManagementDrawer;
